(function () {
  const TIME_ZONE = 'America/New_York';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function getDatePartsInTimeZone(date, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(date);

    const get = (type) => parseInt(parts.find((part) => part.type === type).value, 10);
    let hour = get('hour');
    if (hour === 24) hour = 0;

    return {
      year: get('year'),
      month: get('month'),
      day: get('day'),
      hour,
      minute: get('minute'),
      second: get('second')
    };
  }

  function formatDateYMD({ year, month, day }) {
    return `${year}-${pad(month)}-${pad(day)}`;
  }

  function getTimestampInTimeZone(dateStr, timeStr, timeZone) {
    const [year, month, day] = dateStr.split('-').map(Number);
    const timeParts = (timeStr || '00:00:00').split(':').map(Number);
    const hour = timeParts[0] || 0;
    const minute = timeParts[1] || 0;
    const second = timeParts[2] || 0;

    let testDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));

    for (let i = 0; i < 3; i++) {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).formatToParts(testDate);

      const get = (type) => parseInt(parts.find((part) => part.type === type).value, 10);
      let tzHour = get('hour');
      if (tzHour === 24) tzHour = 0;

      const desired = Date.UTC(year, month - 1, day, hour, minute, second);
      const actual = Date.UTC(get('year'), get('month') - 1, get('day'), tzHour, get('minute'), get('second'));
      testDate = new Date(testDate.getTime() + (desired - actual));
    }

    return testDate.getTime();
  }

  function getNextDailyResetTimestamp(repeatTimeStr, timeZone) {
    const todayParts = getDatePartsInTimeZone(new Date(), timeZone);
    const todayDate = formatDateYMD(todayParts);
    let target = getTimestampInTimeZone(todayDate, repeatTimeStr, timeZone);

    if (Date.now() >= target) {
      const noonToday = getTimestampInTimeZone(todayDate, '12:00:00', timeZone);
      const tomorrowParts = getDatePartsInTimeZone(new Date(noonToday + 86400000), timeZone);
      target = getTimestampInTimeZone(formatDateYMD(tomorrowParts), repeatTimeStr, timeZone);
    }

    return target;
  }

  function getIntervalMinutes(element) {
    return parseInt(element.dataset.intervalMinutes, 10) || 5;
  }

  function isCartIntervalTimer(element) {
    return element.dataset.mode === 'interval' && element.dataset.intervalReset === 'cart';
  }

  function getCartIntervalCookieKey(element) {
    const id = element.id || 'cart-countdown';
    return 'rocco_countdown_start_' + id;
  }

  function readCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, maxAgeSeconds) {
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; Max-Age=' +
      maxAgeSeconds +
      '; Path=/; SameSite=Lax' +
      secure;
  }

  function clearCartIntervalCookie(element) {
    writeCookie(getCartIntervalCookieKey(element), '', 0);
    element.dataset.intervalStartedAt = '';
  }

  function loadCartIntervalStart(element) {
    const stored = readCookie(getCartIntervalCookieKey(element));
    const startedAt = parseInt(stored, 10);

    if (startedAt) {
      element.dataset.intervalStartedAt = String(startedAt);
      return;
    }

    element.dataset.intervalStartedAt = '';
  }

  function resetIntervalTimer(element) {
    const startedAt = Date.now();
    const intervalMinutes = getIntervalMinutes(element);
    const maxAge = intervalMinutes * 60 + 86400;

    element.dataset.intervalStartedAt = String(startedAt);
    writeCookie(getCartIntervalCookieKey(element), String(startedAt), maxAge);
  }

  function getSyncedIntervalRemainingMs(intervalMinutes) {
    const intervalMs = intervalMinutes * 60 * 1000;
    let remaining = intervalMs - (Date.now() % intervalMs);

    if (remaining === intervalMs) {
      remaining = 0;
    }

    return remaining;
  }

  function getCartIntervalRemainingMs(element) {
    const intervalMs = getIntervalMinutes(element) * 60 * 1000;
    const startedAt = parseInt(element.dataset.intervalStartedAt, 10);

    if (!startedAt) {
      return 0;
    }

    const elapsed = Date.now() - startedAt;

    if (elapsed >= intervalMs) {
      return 0;
    }

    return intervalMs - elapsed;
  }

  function getRemainingMs(element) {
    const mode = element.dataset.mode || 'daily';

    if (mode === 'interval') {
      if (isCartIntervalTimer(element)) {
        return getCartIntervalRemainingMs(element);
      }

      return getSyncedIntervalRemainingMs(getIntervalMinutes(element));
    }

    const repeatTime = element.dataset.repeatTime || '00:00:00';
    return Math.max(getNextDailyResetTimestamp(repeatTime, TIME_ZONE) - Date.now(), 0);
  }

  function resetCartIntervalTimers() {
    document.querySelectorAll('[data-countdown-timer][data-interval-reset="cart"]').forEach(function (timer) {
      resetIntervalTimer(timer);
      refreshTimer(timer);
    });
  }

  const timerTicks = new WeakMap();

  function refreshTimer(element) {
    const tick = timerTicks.get(element);
    if (typeof tick === 'function') {
      tick();
    }
  }

  function getInitialCartItemCount() {
    if (typeof window.cartCount !== 'undefined') {
      return Number(window.cartCount) || 0;
    }

    if (window.CartJS && window.CartJS.cart) {
      return Number(window.CartJS.cart.item_count) || 0;
    }

    return 0;
  }

  function initTimer(element) {
    if (element.dataset.countdownInitialized === 'true') return;

    const display = element.querySelector('[data-countdown-display]');
    if (!display) return;

    const mode = element.dataset.mode || 'daily';
    const daysEl = display.querySelector('[data-unit="days"]');
    const daysGroup = display.querySelector('[data-countdown-days-group]');
    const hoursEl = display.querySelector('[data-unit="hours"]');
    const hoursGroup = hoursEl ? hoursEl.closest('[data-countdown-hours-group]') : null;
    const minutesEl = display.querySelector('[data-unit="minutes"]');
    const secondsEl = display.querySelector('[data-unit="seconds"]');

    if (isCartIntervalTimer(element)) {
      loadCartIntervalStart(element);
    }

    element.dataset.countdownInitialized = 'true';

    function tick() {
      const diff = getRemainingMs(element);
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (daysGroup) daysGroup.hidden = mode === 'interval' || days === 0;
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (hoursGroup) hoursGroup.hidden = mode === 'interval' || hours === 0;
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      element.classList.remove('is-expired');
      element.hidden = false;
    }

    timerTicks.set(element, tick);
    tick();

    window.setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-countdown-timer]').forEach(initTimer);
  }

  function handleCartIntervalUpdate(cart) {
    const cartTimers = document.querySelectorAll('[data-countdown-timer][data-interval-reset="cart"]');
    const itemCount = Number(cart && cart.item_count) || 0;

    if (!cartTimers.length) return;

    if (itemCount === 0) {
      cartTimers.forEach(clearCartIntervalCookie);
      cartTimers.forEach(refreshTimer);
      handleCartIntervalUpdate.previousCartItemCount = 0;
      return;
    }

    if (itemCount > handleCartIntervalUpdate.previousCartItemCount) {
      cartTimers.forEach(function (timer) {
        resetIntervalTimer(timer);
        refreshTimer(timer);
      });
    }

    handleCartIntervalUpdate.previousCartItemCount = itemCount;
  }

  handleCartIntervalUpdate.previousCartItemCount = getInitialCartItemCount();

  function bindCartIntervalReset() {
    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', function (_evt, cart) {
        handleCartIntervalUpdate(cart);
      });
    }

    window.addEventListener('ig:CartUpdated', function () {
      if (window.CartJS && window.CartJS.cart) {
        handleCartIntervalUpdate(window.CartJS.cart);
      }
    });
  }

  function boot() {
    initAll();
    bindCartIntervalReset();
  }

  if (window.jQuery) {
    window.jQuery(boot);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
